export default () => {
    // Get the hero form wrapper element
    // only on the Form Landing template
    const heroFormWrapper = document
        .querySelector('.hero-landing-form .hero-form-wrapper')

    // If there's no heroFormWrapper, return
    if (!heroFormWrapper)
        return

    const hero = document
        .querySelector('.hero')

    const main = document
        .querySelector('#content')

    const updSize = () => {
        const heroHeight = hero
            .offsetHeight || 0

        const formHeight = heroFormWrapper
            .offsetHeight || 0

        if (formHeight > heroHeight)
            main.setAttribute('style',
                `--hero-form-wrapper-height: ${formHeight}px`)
    }

    window.addEventListener('resize',
        updSize)

    window.addEventListener('message', (e) => {
        // Check if the message is from HubSpot Forms and the event is 'onFormReady'
        if (e.data.type === 'hsFormCallback'
                && e.data.eventName === 'onFormReady')
            updSize()
    })
}
